var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"scroll":_vm.handleScroll}},[_c('Menu',{key:_vm.color,attrs:{"color":_vm.color}}),_c('Banner'),_c('MiddleBanner'),_c('Caracteristicas'),_c('BannerSlider'),_c('Beneficios'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }